import { CourseLocationState } from './types';

export const state = (): CourseLocationState => initialState();

export const initialState = (): CourseLocationState => ({
  courseLocations: [],
});
